import React from 'react';
import SEO from './SEO';
import styleClasses from './css/AboutUs.module.scss';

const TermsOfService = () => {
  return (
    <>
      <SEO title={'이용약관'} />
      <div className={styleClasses.aboutUs}>
        <div className={styleClasses.inner}>
          <div className={styleClasses.hero}>
            <h1 className={styleClasses.title}>이용약관</h1>
          </div>
          <div className={styleClasses.content}>
            <section>
              <h3>제1조 (목적)</h3>
              <p>
                이 약관은 뮤지직(Musizic)(이하 "회사")이 운영하는 온라인 플랫폼에서 제공하는 <strong>뮤지카드(MusiCard)</strong> 서비스(이하 "서비스")의 이용과 관련하여 회사와 이용자 간의 권리, 의무 및 책임 사항을 규정하는 것을 목적으로 합니다.
              </p>
              <h3>제2조 (용어의 정의)</h3>
              <ol>
                <li>
                  <strong>플랫폼</strong>: 회사가 운영하는 웹사이트 및 애플리케이션을 의미합니다.
                </li>
                <li>
                  <strong>회원</strong>: 본 약관에 동의하고 서비스에 가입하여 계정을 생성한 자를 의미합니다.
                </li>
                <li>
                  <strong>뮤지카드(MusiCard)</strong>: 회원이 직접 제작할 수 있는 <strong>온라인 명함형 홍보 페이지</strong>를 의미합니다.
                </li>
                <li>
                  <strong>콘텐츠</strong>: 회원이 뮤지카드에 업로드하는 이미지, 음악, 동영상, 텍스트 등 모든 데이터를 포함합니다.
                </li>
                <li>
                  <strong>유료 서비스</strong>: 회사가 제공하는 <strong>뮤지카드 추가 제작, 협업 시스템 이용 등 특정 기능</strong>을 포함하며, 향후 서비스 확장에 따라 변동될 수 있습니다.
                </li>
              </ol>
              <h3>제3조 (약관의 효력 및 변경)</h3>
              <ol>
                <li>본 약관은 회원이 서비스 이용 시 동의함으로써 효력이 발생합니다.</li>
                <li>
                  회사는 관련 법령을 준수하는 범위 내에서 본 약관을 개정할 수 있으며, 변경 사항은 7일 전(중요한 변경 사항은 30일 전) 공지합니다.
                </li>
                <li>
                  회원이 개정 약관에 동의하지 않는 경우, 서비스 이용을 중단하고 회원 탈퇴를 요청할 수 있습니다.
                </li>
              </ol>
              <h3>제4조 (회원가입 및 계정 관리)</h3>
              <ol>
                <li>회원가입은 이메일, SNS 로그인 등을 통해 이루어지며, 가입 시 정확한 정보를 제공해야 합니다.</li>
                <li>계정 보안은 회원의 책임이며, 타인에게 계정을 양도하거나 공유해서는 안 됩니다.</li>
                <li>
                  허위 정보 입력, 타인의 계정 도용 등 부정한 가입이 확인될 경우, 회사는 사전 통보 없이 계정을 정지할 수 있습니다.
                </li>
              </ol>
              <h3>제5조 (서비스 이용 및 제한)</h3>
              <ol>
                <li>회원은 제공된 기능을 활용하여 자유롭게 뮤지카드를 제작하고 공유할 수 있습니다.</li>
                <li>
                  다음과 같은 콘텐츠 업로드 및 활동은 금지됩니다.
                  <ul>
                    <li>타인의 저작권을 침해하는 행위</li>
                    <li>음란물, 폭력적이거나 혐오적인 콘텐츠 게시</li>
                    <li>허위 정보 유포 및 사기 행위</li>
                    <li>기타 사회적 질서를 해치는 행위</li>
                  </ul>
                </li>
                <li>
                  회사는 위반 행위가 확인될 경우, 경고 없이 콘텐츠 삭제 및 계정 정지 등의 조치를 취할 수 있습니다.
                </li>
              </ol>
              <h3>제6조 (유료 서비스 및 결제)</h3>
              <ol>
                <li>
                  회사는 <strong>뮤지카드 추가 제작, 협업 시스템 등 특정 기능</strong>을 유료 서비스로 제공할 수 있으며, 향후 서비스 확장에 따라 세부 내용이 변경될 수 있습니다.
                </li>
                <li>
                  결제는 카드, 계좌이체 등 다양한 방식으로 가능하며, 구체적인 결제 방식 및 가격 정책은 서비스 페이지에서 안내됩니다.
                </li>
                <li>
                  유료 서비스의 해지 및 환불 규정은 <strong>환불 및 결제 정책</strong>에서 별도로 정합니다.
                </li>
                <li>
                  회사는 이용자가 결제 후 정상적으로 서비스가 제공되지 않는 경우, 즉시 문제 해결 및 환불을 진행합니다.
                </li>
                <li>
                  회사는 유료 서비스의 기능 추가 및 변경을 시행할 수 있으며, 변경 사항은 사전 공지 후 적용됩니다.
                </li>
              </ol>
              <h3>제7조 (지식재산권 및 저작권 보호)</h3>
              <ol>
                <li>
                  회원이 업로드한 콘텐츠의 저작권은 회원에게 있으며, 회사는 서비스 운영 및 홍보 목적으로 이를 활용할 수 있습니다.
                </li>
                <li>
                  회원은 자신이 올린 콘텐츠에 대한 저작권을 보유해야 하며, 타인의 저작물을 무단 업로드할 경우 법적 책임을 부담할 수 있습니다.
                </li>
                <li>
                  저작권 침해 신고가 접수되면, 회사는 즉시 해당 콘텐츠를 검토하고 필요한 조치를 취할 수 있습니다.
                </li>
              </ol>
              <h3>제8조 (회원 탈퇴 및 서비스 이용 종료)</h3>
              <ol>
                <li>회원은 언제든지 계정 설정을 통해 탈퇴할 수 있으며, 탈퇴 후 데이터는 복구할 수 없습니다.</li>
                <li>
                  회사는 회원이 약관을 위반하거나 장기간 활동이 없는 경우, 서비스 제공을 제한하거나 계정을 삭제할 수 있습니다.
                </li>
                <li>
                  회사는 서비스 종료 시 최소 30일 전에 공지하며, 이용자가 필요 시 데이터를 백업할 수 있도록 조치합니다.
                </li>
              </ol>
              <h3>제9조 (면책 조항)</h3>
              <ol>
                <li>
                  회사는 천재지변, 서버 장애 등 불가항력적인 사유로 서비스 제공이 어려운 경우 책임을 지지 않습니다.
                </li>
                <li>
                  회원이 서비스 이용 과정에서 발생하는 분쟁 및 법적 문제에 대해 회사는 개입하지 않으며, 모든 책임은 회원에게 있습니다.
                </li>
                <li>
                  회사는 회원이 제공한 정보 및 콘텐츠의 정확성을 보장하지 않으며, 이에 대한 모든 책임은 회원 본인에게 있습니다.
                </li>
              </ol>
              <h3>제10조 (준거법 및 분쟁 해결)</h3>
              <ol>
                <li>본 약관과 관련된 분쟁은 대한민국 법률을 따릅니다.</li>
                <li>
                  분쟁이 발생할 경우, 회사와 회원은 원만한 해결을 위해 협의하며, 협의가 어려울 경우 대한민국 법원에서 해결합니다.
                </li>
              </ol>
            </section>
          </div>
        </div>
      </div>
    </>
  );
};

export default TermsOfService;